import { DropdownItem } from "@mcleod/components";
import { AutogenLayoutFmDataOutputTable } from "./autogen/AutogenLayoutFmDataOutputTable";
import { FmDataOutputType } from "./FreightMatchingUtil";

export class FmDataOutputTable extends AutogenLayoutFmDataOutputTable {
    private tableItems: DropdownItem[];
    private type: FmDataOutputType;

    initialize(type: FmDataOutputType): void {
        this.type = type;
    }

    public getTableItems(): DropdownItem[] {
        return this.tableItems;
    }

    public setTableItems(items: DropdownItem[]): void {
        this.tableItems = items;
    }

    public getType(): FmDataOutputType {
        return this.type;
    }
}
